var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Rest } from "../../Rest";
export class SnpApiLegacy extends Rest {
    constructor(baseUrl = "/", tenantToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.name = "SnpApi";
        super.setCommonHeader("X-DES-AK-TENANT-TOKEN", tenantToken);
    }
    subscribe(subscriptionData, preferredLanguage) {
        return __awaiter(this, void 0, void 0, function* () {
            const { email, consent_purposes, data_processing_agreement, preferredLanguage: preferredLanguageFromForm, } = subscriptionData;
            return this.request("/subscribe", {
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
                body: JSON.stringify({
                    email: email,
                    topics: ["marketing"],
                    consents: consent_purposes,
                    data_processing_agreement,
                    preferredLanguage: preferredLanguage !== null && preferredLanguage !== void 0 ? preferredLanguage : preferredLanguageFromForm,
                }),
            }, true);
        });
    }
    unsubscribe(subscriptionUuid, topics, consent_id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.request("/unsubscribe", {
                method: "POST",
                body: JSON.stringify({ topics, uuid: subscriptionUuid, consent_id }),
            });
            return response;
        });
    }
}
//# sourceMappingURL=SnpApiLegacy.js.map